import {useSyncExternalStore} from 'react';

export const DIALER_MIN_WIDTH = 320;
export const DIALER_MAX_WIDTH = 560;
const STORAGE_KEY = 'phq.dialerWidth.v1';

export const clampDialerWidth = (width: number): number =>
    Math.round(Math.min(Math.max(width, DIALER_MIN_WIDTH), DIALER_MAX_WIDTH));

const readStored = (): number => {
    try {
        const stored = Number(window.localStorage.getItem(STORAGE_KEY));
        return Number.isFinite(stored) && stored > 0 ? clampDialerWidth(stored) : DIALER_MIN_WIDTH;
    } catch {
        return DIALER_MIN_WIDTH;
    }
};

let current: number | undefined;
const listeners = new Set<() => void>();

export const dialerWidth = {
    get(): number {
        current ??= readStored();
        return current;
    },
    set(width: number): void {
        current = clampDialerWidth(width);
        try {
            window.localStorage.setItem(STORAGE_KEY, String(current));
        } catch {
            // Width still applies for this session when storage is blocked.
        }
        listeners.forEach(listener => listener());
    },
    subscribe(listener: () => void): () => void {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
    reset(): void {
        current = undefined;
    },
};

export const useDialerWidth = (): number => useSyncExternalStore(dialerWidth.subscribe, dialerWidth.get, () => DIALER_MIN_WIDTH);
